<div [ngClass]="{
    'right-copy-switch-button':side === LensSide.RIGHT,
    'left-copy-switch-button':side === LensSide.LEFT}">
  <app-lens-side-circle *ngIf="side == 'RIGHT'" [side]="side" [ngClass]="{'circle':side === LensSide.RIGHT}"></app-lens-side-circle>
  <app-copy-switch-button [side]="side" (copyEmit)="copy($event)" (switchEmit)="switch($event)"></app-copy-switch-button>
  <app-lens-side-circle *ngIf="side == 'LEFT'" [side]="side" [ngClass]="{'circle':side === LensSide.RIGHT}"></app-lens-side-circle>
</div>

<div>
    <h2 style="margin-bottom: 5px;">{{'newOrder.hechtProposal.tabs.spectacularRefraction.title' | translate}}</h2>
</div>

<div>
    <form [formGroup]="form">

        <div class="d-flex">
            <div class="d-flex spectacular-refraction-parameter">
                <label [matTooltip]="'common.hints.Sphere' | translate" matTooltipPosition="above">{{"common.features.Sphere2" | translate}}<span class="span-label-required"></span>
                    <input formControlName="sphere" class="form-control parameter-input" (blur)="setValueWithFormat('Sphere', 'sphere')"
                    [ngClass]="{required: true, error: form.get('sphere').errors && (form.get('sphere').touched || (form.get('sphere').dirty))}"/>
                </label>
                <div class="info">
                    <img src="assets/img/icons/info.svg" [matTooltip]="'newOrder.finalLens.limits' | translate:getLimitsFormatted(-50,50)" matTooltipPosition="above">
                </div>
            </div>

            <div class="d-flex spectacular-refraction-parameter">
                <label [matTooltip]="'common.hints.Cylinder' | translate" matTooltipPosition="above">{{"common.features.Cylinder" | translate}}<span class="span-label-required"></span>
                    <input formControlName="cylinder" class="form-control parameter-input" (blur)="setValueWithFormat('Cylinder', 'cylinder')"
                    [ngClass]="{required: true, error: form.get('cylinder').errors && (form.get('cylinder').touched || (form.get('cylinder').dirty))}"/>
                </label>
                <div class="info">
                    <img src="assets/img/icons/info.svg" [matTooltip]="'newOrder.finalLens.limits' | translate:getLimitsFormatted(-20,20)" matTooltipPosition="above">
                </div>
            </div>

            <div class="d-flex spectacular-refraction-parameter" [style.marginRight.px]="axisDisable ? '30': '0'">
                <label [matTooltip]="'common.hints.Axis' | translate" matTooltipPosition="above">{{"common.features.Axis" | translate}}<span *ngIf="!axisDisable" class="span-label-required"></span>
                    <input [ngClass]="{required: !axisDisable, error: !axisDisable && form.get('axis').errors && (form.get('axis').touched || (form.get('axis').dirty))}" (blur)="setValueWithFormat('Axis', 'axis')"
                    formControlName="axis" class="form-control parameter-input" placeholder="-" [attr.disabled]="axisDisable ? '' : null"/>
                </label>
                <div class="info" *ngIf="!axisDisable">
                    <img src="assets/img/icons/info.svg" [matTooltip]="'newOrder.finalLens.limits' | translate:getLimitsFormatted(0,179)" matTooltipPosition="above">
                </div>
            </div>

            <div class="d-flex spectacular-refraction-parameter" [style.marginRight.px]="hsaDisable ? '30': '0'">
                <label [matTooltip]="'common.hints.HSA' | translate" matTooltipPosition="above">{{"common.features.HSA2" | translate}}<span *ngIf="!hsaDisable" class="span-label-required"></span>
                    <input [ngClass]="{required: !hsaDisable, error: !hsaDisable && form.get('hsa').errors && (form.get('hsa').touched || (form.get('hsa').dirty))}" (blur)="setValueWithFormat('HSA', 'hsa')"
                     formControlName="hsa" class="form-control parameter-input" placeholder="-" [attr.disabled]="hsaDisable ? '' : null"/>
                </label>
                <div class="info" *ngIf="!hsaDisable">
                    <img src="assets/img/icons/info.svg" [matTooltip]="'newOrder.finalLens.limits' | translate:getLimitsFormatted(5,35)" matTooltipPosition="above">
                </div>
            </div>

            <div class="d-flex spectacular-refraction-parameter">
                <label [matTooltip]="'common.hints.Addition' | translate" matTooltipPosition="above">{{"common.features.Addition" | translate}}<span class="span-label-required"></span>
                    <input formControlName="addition" class="form-control parameter-input" (blur)="setValueWithFormat('Addition', 'addition')"
                    [ngClass]="{required: true, error: form.get('addition').errors && (form.get('addition').touched || (form.get('addition').dirty))}"/>
                </label>
                <div class="info">
                    <img src="assets/img/icons/info.svg" [matTooltip]="'newOrder.finalLens.limits' | translate:getLimitsFormatted(0,4)" matTooltipPosition="above">
                </div>
            </div>
        </div>

        <div class="d-flex">
            <div class="d-flex spectacular-refraction-calculation-parameter">
                <input formControlName="sphereCalc" class="form-control" [attr.disabled]="true"/>
            </div>

            <div class="d-flex spectacular-refraction-calculation-parameter">
                <input formControlName="cylinderCalc" class="form-control" [attr.disabled]="true"/>
            </div>

            <div class="d-flex spectacular-refraction-calculation-parameter">
                <input formControlName="axisCalc" class="form-control" [attr.disabled]="true"/>
            </div>

            <div class="d-flex spectacular-refraction-calculation-parameter">
                <input formControlName="hsaCalc" class="form-control" [attr.disabled]="true"/>
            </div>
        </div>

    </form>

    <app-validation-error [form]="form"></app-validation-error>
</div>
